import type { SxProps, Theme } from '@mui/material/styles';

/** Figma agent selector theme — outlined inputs (text, hex, select). */
export const AGENT_SELECTOR_FIELD_HEIGHT_PX = 48;

const outlinedFieldRootSx = {
  m: 0,
  width: '100%',
} satisfies SxProps<Theme>;

const outlinedInputSx = {
  ...outlinedFieldRootSx,
  '& .MuiOutlinedInput-root': {
    height: AGENT_SELECTOR_FIELD_HEIGHT_PX,
    borderRadius: '8px',
  },
  '& .MuiOutlinedInput-input': {
    boxSizing: 'border-box',
    height: '100%',
  },
  '& .MuiSelect-select': {
    boxSizing: 'border-box',
    height: `${AGENT_SELECTOR_FIELD_HEIGHT_PX}px`,
    display: 'flex',
    alignItems: 'center',
    py: 0,
  },
} satisfies SxProps<Theme>;

/** Full-width text fields (e.g. mobile label text). */
export const agentSelectorTextFieldSx: SxProps<Theme> = {
  ...outlinedInputSx,
};

/** Hex input beside color swatch (198px max). */
export const agentSelectorColorTextFieldSx: SxProps<Theme> = {
  flex: 1,
  maxWidth: 198,
  ...outlinedInputSx,
};

/** Outlined select (e.g. mobile leading icon). */
export const agentSelectorFormControlSx: SxProps<Theme> = {
  ...outlinedInputSx,
};

export const agentSelectorColorSwatchSx: SxProps<Theme> = {
  width: AGENT_SELECTOR_FIELD_HEIGHT_PX,
  height: AGENT_SELECTOR_FIELD_HEIGHT_PX,
  flexShrink: 0,
  borderRadius: '4px',
  border: '1px solid',
  borderColor: '#E0E0E0',
  p: 0,
};

export const agentSelectorColorFieldRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'space-between',
  gap: '19px',
  width: '100%',
};
